import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './FullscreenGalleryFooter.css';

interface IFullscreenGalleryFooterProps {
  userName: string;
  offerStr: string;
}

export const FullscreenGalleryFooter: React.FC<IFullscreenGalleryFooterProps> = ({ userName, offerStr }) => {
  return (
    <div className={styles['footer']} data-testid="FullscreenGalleryFooter">
      {userName && (
        <div className={styles['user_name']} data-testid="FullscreenGalleryFooterUserName">
          <UIText1 color="text-inverted-default">{userName}</UIText1>
        </div>
      )}
      {offerStr && (
        <div className={styles['offer']} data-testid="FullscreenGalleryFooterOfferStr">
          <UIText1 color="text-primary-disabled">{offerStr}</UIText1>
        </div>
      )}
    </div>
  );
};
